// Shared styles for the TracPatch config modal & override form.
// Aim: white card per section, icon badge + uppercase title, labels above
// full-width rounded inputs (matches the design mockup).

export const cardStyle = {
  background: '#fff',
  border: '1px solid #eef0f3',
  borderRadius: 12,
  padding: '18px 20px',
  marginBottom: 14,
  boxShadow: '0 1px 2px rgba(16,24,40,0.04)',
}

export const sectionHeaderRow = {
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  marginBottom: 14,
}

export const sectionTitle = {
  fontSize: 12,
  fontWeight: 700,
  letterSpacing: 1.2,
  color: '#0f172a',
}

export const iconBadge = (bg) => ({
  width: 28,
  height: 28,
  borderRadius: 8,
  background: bg,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 14,
})

export const fieldLabelStyle = {
  display: 'block',
  fontSize: 12,
  fontWeight: 600,
  color: '#334155',
  marginBottom: 6,
}

export const overriddenDot = {
  display: 'inline-block',
  width: 6,
  height: 6,
  borderRadius: '50%',
  background: '#1890ff',
  marginLeft: 6,
  verticalAlign: 'middle',
}
